import { createFileRoute } from "@tanstack/react-router";
import { TiersScreen } from "../components/clients/TiersScreen";

export const Route = createFileRoute("/_auth/clients/tiers")({
  staticData: {
    titleKey: "clients.tiers.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 3,
  },
  component: TiersScreen,
});
